import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[onlineAppToggleViewPassword]'
})
export class ToggleViewPasswordDirective {
  private _shown = false;

  constructor(private el: ElementRef) {
    this.setup();
  }

  toggle(button: HTMLElement) {
    this._shown = !this._shown;
    if (this._shown) {
      this.el.nativeElement.setAttribute('type', 'text');
      button.setAttribute('aria-label', 'Show password');
      button.setAttribute('role', 'button');
      button.innerHTML = '<i class="fa fa-eye fa-2x" aria-hidden="true" focusable="false"></i>';
    } else {
      this.el.nativeElement.setAttribute('type', 'password');
      button.setAttribute('aria-label', 'Hide password');
      button.setAttribute('role', 'button');
      button.innerHTML = '<i class="fa fa-eye-slash fa-2x" aria-hidden="true" focusable="false"></i>';
    }
  }

  setup() {
    const parent = this.el.nativeElement.parentNode;
    const button = document.createElement('a');
    button.innerHTML = `<i class="fa fa-eye-slash fa-2x" aria-hidden="true" focusable="false"></i>`

    button.setAttribute('class', 'btn btn-link btn-toggle');
    button.setAttribute('tabindex', '0');
    button.setAttribute('aria-label', 'Hide password');
    button.setAttribute('role', 'button');

    button.addEventListener('click', (event) => {
      this.toggle(button);
    });
    button.addEventListener('keyup', (event) => {
      if (event.keyCode === 13) {
        event.stopPropagation();
        this.toggle(button);
      }
      if (event.keyCode === 9) {
        this.keyboardPanelFocus(event);
      }
    });
    button.addEventListener('blur', (event) => {
      this.keyboardPanelBlur(event);
    });
    parent.appendChild(button);
  }

  keyboardPanelFocus(event): void {
    event.target.style.outline = "1px solid blue";
  }
  keyboardPanelBlur(event): void {
    event.target.style.outline = "";
  }
}
